export function getVerticalAlign(state, defaultAlign = 'bottom') {
    const { view: { verticalAlign, spectra: { activeTab }, }, } = state;
    return verticalAlign?.[activeTab] || defaultAlign;
}
